import app from "js/legacy-app";

app.controller('ShowOrganisationRequestsCtrl', ['$scope', '$routeParams', function ($scope, $routeParams) {

    $scope.organisationId = $routeParams.id;

}]);